const project = process.env.REACT_APP_PROJECT;
console.log(project);
const tilesData = {
  saostar: [
    //1
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat("1.6"),
      thumbSize: 600,
      className: "top-1",
      pr: "1",
    },
    //2
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat("0.7"),
      thumbSize: 600,
      thumbType: "ver-thumb",
      className: "top-2 no-sapo ml-auto",
      pr: "2",
    },
    //3
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat("0.7"),
      thumbSize: 600,
      thumbType: "ver-thumb",
      className: "top-2 no-sapo ml-auto",
      pr: "2",
    },
    //4
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "3",
      className: "w--268 mt-4 fz20 no-sapo",
    },
    //5
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "3",
      className: "mx-auto w--268 mt-4 fz20 no-sapo",
    },
    //6
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "3",
      className: "mx-auto w--268 mt-4 fz20 no-sapo",
    },
    //7
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      className: "ml-auto w--268 mt-4 fz20  no-sapo",
    },
    //8
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "5",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //9
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //10
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //11
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //12
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //13
    //special
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      // thumbType: "ver-thumb",
      className: "special no-sapo",
      pr: "10",
    },
    //14
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      // thumbType: "ver-thumb",
      className: "special no-sapo",
      pr: "10",
    },
    //15
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
      pr: "10",
    },
    //16
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
    },
    // 17
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
    },
    //end special
    //18
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
      pr: "6",
    },
    //19
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //20
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //21
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //22
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //23
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 border-bottom ",
      pr: "7",
    },
    //24
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //25
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //26
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //27
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //28
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //29
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //30
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //31
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //32
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3",
    },
    // //33
    // // socialIcon
    // {
    //   type: "auto",
    //   post: null,
    //   autoGetBy: "newest",
    //   tag: null,
    //   expiredAt: null,
    //   rows: 1,
    //   cols: 3,
    //   showDuplicationSetting: true,
    //   className: "no-sapo thumb-w--260 pb-4 pt-3",
    // },
    // // 34
    // {
    //   type: "auto",
    //   post: null,
    //   autoGetBy: "newest",
    //   tag: null,
    //   expiredAt: null,
    //   rows: 2,
    //   cols: 2,
    //   showDuplicationSetting: true,
    //   className: "no-sapo thumb-w--260 pb-4 pt-3",
    // },
    // // 35
    // {
    //   type: "auto",
    //   post: null,
    //   autoGetBy: "newest",
    //   tag: null,
    //   expiredAt: null,
    //   rows: 2,
    //   cols: 2,
    //   showDuplicationSetting: true,
    //   className: "no-sapo thumb-radius-0",
    // },
    // // 36
    // {
    //   type: "auto",
    //   post: null,
    //   autoGetBy: "newest",
    //   tag: null,
    //   expiredAt: null,
    //   rows: 2,
    //   cols: 2,
    //   showDuplicationSetting: true,
    //   className: "no-sapo thumb-radius-0",
    // },
    // // 37
    // {
    //   type: "auto",
    //   post: null,
    //   autoGetBy: "newest",
    //   tag: null,
    //   expiredAt: null,
    //   rows: 2,
    //   cols: 2,
    //   showDuplicationSetting: true,
    //   className: "no-sapo thumb-radius-0",
    // },
    // // end socialIcon
    //38
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
      pr: "8",
    },
    //39
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //40
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //41
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    //42
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
  ],
  showbiz: [
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2.15,
      thumbSize: 600,
      className: "top-1",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat("0.85"),
      thumbSize: 400,
      thumbType: "ver-thumb",
      thumbMobileType: "hor-thumb",
      cardMobileType: "hor-card",
      className: "top-2 no-sapo ml-auto",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "1",
      className: "w--260 mt-4 fz20  no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "1",
      className: "mx-auto w--260 mt-4 fz20  no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 1,
      pr: "1",
      className: "ml-auto w--260 mt-4 fz20  no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "2",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "2",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "3",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "3",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      pr: "3",
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3 border-bottom ",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 1,
      cols: 3,
      cardType: "hor-card",
      className: "no-sapo thumb-w--260 pb-4 pt-3",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat(3 / 5),
      showDuplicationSetting: true,
      // thumbType: "ver-thumb",
      className: "special no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat(3 / 5),
      showDuplicationSetting: true,
      // thumbType: "ver-thumb",
      className: "special no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat(3 / 5),
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat(3 / 5),
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: parseFloat(3 / 5),
      // thumbType: "ver-thumb",
      showDuplicationSetting: true,
      className: "special no-sapo",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
    {
      type: "auto",
      post: null,
      autoGetBy: "newest",
      tag: null,
      expiredAt: null,
      rows: 2,
      cols: 2,
      showDuplicationSetting: true,
      className: "no-sapo thumb-radius-0",
    },
  ],
};

const homeDefaultSetting = {
  tiles: tilesData[project],
};
export default homeDefaultSetting;
